import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <span> Tạo bởi ThinhTPT </span> <br />
      <span> Hướng dẫn bởi MinhHY </span> <br />
      <a
        href="https://www.facebook.com/fcodefpt/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span> Bản quyền © 2019 F-Code HCM </span>
      </a>
    </footer>
  )
}

export default Footer;
